import { Badge, Text } from '@chakra-ui/react'
import { useElapsedTimer } from '@/hooks/useSlaTimer'

export function QueueWaitCell({
  acknowledgedAt,
  parentTicketCreatedAt,
}: {
  acknowledgedAt?: string | null
  parentTicketCreatedAt?: string | null
}) {
  if (!acknowledgedAt || typeof acknowledgedAt !== 'string') {
    return (
      <Text as="span" color="gray.500">
        –
      </Text>
    )
  }

  return (
    <QueueWaitCellInner
      acknowledgedAt={acknowledgedAt}
      parentTicketCreatedAt={parentTicketCreatedAt}
    />
  )
}

function QueueWaitCellInner({
  acknowledgedAt,
  parentTicketCreatedAt,
}: {
  acknowledgedAt: string
  parentTicketCreatedAt?: string | null
}) {
  const { elapsedText, isFrozen } = useElapsedTimer(acknowledgedAt, parentTicketCreatedAt)

  if (isFrozen) {
    return (
      <Badge colorScheme="gray" variant="subtle" whiteSpace="nowrap" title="Wait until ticket created">
        {elapsedText}
      </Badge>
    )
  }

  return (
    <Badge colorScheme="orange" whiteSpace="nowrap" title="Waiting for ticket creation">
      {elapsedText}
    </Badge>
  )
}
